import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import Request from "common/Request";
import Result from "./Result";
import { parseResult, parseRangesFromParams, buildLabelByRTT } from "./api";
import ActionsContext from "common/ActionsContext";
import { safeStr } from "common/api";

const ViewContainer = styled.div`
  min-height: 50vh;
  &.card {
    height: 100%;
  }
`;


const ContextMenu = ({reloadSignal='do-load'}) => {
  const actions = useContext(ActionsContext);
  return (
    <ul className="context-menu header-dropdown m-r--5">
      <li>
        <a
          onClick={() => actions.send(reloadSignal)}
          data-toggle="cardloading"
          data-loading-effect="pulse"
          title="Refresh"
        >
          <i className="material-icons">refresh</i>
        </a>
      </li>
    </ul>
  );
};

const HeaderDiv = styled.div`
  display: flex & .title {
    flex: 100% 1 1;
    padding-right: 2.5ch;
  }
`;

export const labelRangesRetrieval = () =>
  ifCl
    .run("show pkteng parameters")
    .then(parseRangesFromParams)
    .then(([...ranges]) => buildLabelByRTT(...ranges));

const speedInfoRetrieval = (hours, subscriberGroup) => {
  const cmdSubscriberGroup = subscriberGroup ? ` subscriber-groups name ${safeStr(subscriberGroup)}` : "";
  return ifCl.run(`show pkteng speed domain all hours ${hours} max 10${cmdSubscriberGroup}`, {
    timeout: DPI_STATS_TMOUT_MS,
  });
}

const acquireParamsAndData = (hours, subscriberGroup) =>
  Promise.all([labelRangesRetrieval(), speedInfoRetrieval(hours, subscriberGroup)])
    .then(([labelByRTT, speedInfo]) => {
      const result = parseResult(speedInfo, labelByRTT);
      result.download.services = result.download.services.slice(0, 5);
      result.upload.services = result.upload.services.slice(0, 5);
      return result;
    })
    .then((result) => ({ result }));

const TCPOComparison = ({subscriberGroup, reloadSignal='do-load'}) => {
  const actions = useContext(ActionsContext);
  const [request, setRequest] = useState(null);
  const [hours, setHours] = useState(24);

  const doLoad = (hours, subscriberGroup) => {
    setRequest(acquireParamsAndData(hours, subscriberGroup));
  };

  useEffect(
    () => doLoad(hours, subscriberGroup) || actions.recv(reloadSignal, () => doLoad(hours, subscriberGroup)),
    [hours, subscriberGroup]
  );

  return (
    <ViewContainer className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div className="card">
        <HeaderDiv className="header block-header">
          <h2 className="title">TCP Speed & Acceleration</h2>
          <small>
            Comparison of TCP connection average speed with and without TCP
            Optimization (TCPO).
          </small>
          <ContextMenu reloadSignal={reloadSignal}/>
        </HeaderDiv>
        <div className="body flex-panel-column">
          <Request during={request}>
            {(response) => (
              <Result
                {...response}
                onHoursChange={(value) => setHours(value)}
                hours={hours}
              />
            )}
          </Request>
        </div>
      </div>
    </ViewContainer>
  );
};

export default TCPOComparison;
